<!-- Start -->
<section class="relative bg-[url('/assets/images/parallax/shaolin2_1920x1200.jpg')] bg-no-repeat bg-center">
  <div class="absolute inset-0 bg-slate-900/40"></div>
  <div class="absolute inset-0 bg-gradient-to-b from-transparent to-slate-900"></div>
  <div class="container-fluid relative">
    <div class="grid grid-cols-1">
      <div class="flex flex-col min-h-screen justify-center md:px-10 py-10 px-4">
        <div class="title-heading text-center my-auto">
          <div class="md:my-0 my-10">
            <div class="wave-effect relative tracking-tighter mb-6 md:text-5xl text-3xl font-bold text-white">
              <span class="relative inline-block">{{ 'INDEX.GAME_NAME' | translate }}</span>
            </div>
            <p class="text-white/70 max-w-xl mx-auto">{{ 'INDEX.INDEX_DESCRIPTION' | translate }}</p>

            <div id="countdown">
              <ul class="count-down list-none inline-block text-white text-center mt-8">
                <li id="days" class="count-number inline-block m-2">{{days}} <p class="count-head">{{ 'DAYS' | translate }}</p></li>
                <li id="hours" class="count-number inline-block m-2">{{hours}} <p class="count-head">{{ 'HOURS' | translate }}</p></li>
                <li id="mins" class="count-number inline-block m-2">{{minutes}} <p class="count-head">{{ 'MINUTES' | translate }}</p></li>
                <li id="secs" class="count-number inline-block m-2">{{seconds}} <p class="count-head">{{ 'SECONDS' | translate }}</p></li>
                <li id="end" class="h1"></li>
              </ul>
            </div>

            <div class="mt-6">
              <a [routerLink]="'/download'" class="btn bg-violet-600 hover:bg-violet-700 border-violet-600 hover:border-violet-700 text-white rounded-full me-2 mt-2">
                {{ 'INDEX.DOWNLOAD' | translate }}
              </a>
              <a [routerLink]="'/home'" class="btn bg-transparent hover:bg-violet-600 border-violet-600 text-violet-600 hover:text-white rounded-full mt-2">
                {{ 'INDEX.GOTO_HOME' | translate }}
              </a>
            </div>
          </div>
        </div>
      </div>
    </div><!--end grid-->
  </div><!--end container-->
</section><!--end section-->
<!-- End -->
